/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The `mime-types` returned or sent as an `Accept` header.
 */
export type DocumentMimeTypes = 'application/pdf+SAP-worksheet' | 'application/pdf+site-notes';

export const DocumentMimeTypes = {
    SapWorksheet: 'application/pdf+SAP-worksheet' as DocumentMimeTypes,
    SiteNotes: 'application/pdf+site-notes' as DocumentMimeTypes
};

